import { Color, Spacing } from '@persona-id/design-tokens';
import { XIcon } from '@persona-id/design-tokens/icons/24px';
import styled from 'styled-components';

import NodeFunctionSelector from 'dashboard/forms/FormCreateGraphNode/NodeFunctionSelector';
import Form from 'dashboard/layouts/FormLayout/Form';
import { ModalContainer } from 'dashboard/layouts/ModalLayout';
import { PresetType, ServerPresetSummary } from 'dashboard/models/graph-backend';
import Button from 'design-system/components/Button';
import { Heading } from 'design-system/components/Text';
import { useFormSecurely } from 'lib/security/reactHookForm';

interface AddFunctionModalProps {
  onAddFunction: (values: AddFunctionFormData) => void;
  presetSummaries: ServerPresetSummary[];
  setIsOpen: (isOpen: boolean) => void;
}

export interface AddFunctionFormData {
  presetType: PresetType;
}

const HeadingContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${Spacing[5]} ${Spacing[5]} ${Spacing[3]} ${Spacing[5]};
  border-bottom: 1px solid ${Color.CoreSlate100};
`;

const StyledModalContainer = styled(ModalContainer)`
  padding-top: 0;
`;

const ButtonContainer = styled.div<{ withBorder: boolean }>`
  ${({ withBorder }) => withBorder && `padding-bottom: ${Spacing[5]};`}
  border-top: 1px solid ${Color.CoreSlate100};
  display: flex;
  justify-content: flex-end;
  padding: ${Spacing[5]};
`;

const AddFunctionModal = ({ onAddFunction, presetSummaries, setIsOpen }: AddFunctionModalProps) => {
  const { control, handleSubmit } = useFormSecurely<AddFunctionFormData>({
    defaultValues: {
      presetType: presetSummaries?.[0]?.preset,
    },
  });

  const handleFormSubmit = () => {
    handleSubmit(onAddFunction)();
    setIsOpen(false);
  };

  return (
    <StyledModalContainer size='xl'>
      <HeadingContainer>
        <Heading size='sm'>Select a Function</Heading>
        <XIcon id='add-function-modal__close-button' onClick={() => setIsOpen(false)} />
      </HeadingContainer>
      <Form id='form-add-node-function'>
        <NodeFunctionSelector control={control} presetSummaries={presetSummaries} />
        <ButtonContainer withBorder>
          <Button
            id='add-function-modal__submit-button'
            width='auto'
            type='button'
            onClick={handleFormSubmit}
          >
            Next
          </Button>
        </ButtonContainer>
      </Form>
    </StyledModalContainer>
  );
};

export default AddFunctionModal;
